import { Text } from '@components';
import { CustomApi } from '@services';
import { useState } from 'react';
import { Button, Col, Form, Row } from 'react-bootstrap';
import { Loading, toast } from '../../components';
import CloseModal from '../../components/modals/CloseModal';

function CreateAppModal({ onClose, setTriggerUpdate }) {
  const [appName, setAppName] = useState('');
  const [description, setDescription] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const isValidAppName = () =>
    /^[A-Za-z0-9][A-Za-z0-9\s!@#$%^&*()-=_+[\]{}|;:'",.<>?/~`]*$/.test(appName);

  const handleAppNameChange = (e) => {
    setAppName(e.target.value);
  };

  const handleDescriptionChange = (e) => {
    setDescription(e.target.value);
  };

  const handleSubmit = async () => {
    try {
      setIsLoading(true);

      if (!isValidAppName()) {
        toast.error('Invalid Application name format.');
        return;
      }

      // Make API call to create application
      await CustomApi.post('/api/applications', { name: appName, description });

      toast.success('Application created successfully!');
    } catch (error) {
      toast.error('Failed to create Application.');
    } finally {
      onClose();
      // triggers serversidegrid debounceFetchData
      setTriggerUpdate(true);
    }
  };

  return (
    <>
      {isLoading ? (
        <Loading />
      ) : (
        <>
          <CloseModal close={onClose} />
          <Text as="h3" className="text-center">
            Create Application
          </Text>
          <Form className="mt-5 mb-4">
            <Form.Group as={Row} className="d-block" controlId="formAppName">
              <Col sm={8} className="m-auto">
                <Form.Label className="pt-2">Application Name:</Form.Label>
                <Form.Control
                  className="mb-3"
                  type="text"
                  value={appName}
                  onChange={handleAppNameChange}
                />
                <Form.Label className="pt-2">Description:</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={3}
                  value={description}
                  onChange={handleDescriptionChange}
                />
              </Col>
            </Form.Group>
          </Form>
          <div className="text-center">
            <Button
              className="w-50 mb-4 mt-3"
              variant="primary"
              onClick={handleSubmit}
              disabled={!isValidAppName() || isLoading}
            >
              Create
            </Button>
          </div>
        </>
      )}
    </>
  );
}

export default CreateAppModal;
